import { abbreviateNumber } from 'utils/format';

interface MetricCardProps {
  title: string;
  value: string;
  disableAbbreviation?: boolean;
}

export const MetricCard = ({
  title,
  value,
  disableAbbreviation = false,
}: MetricCardProps) => {
  return (
    <div className="flex-1 rounded-2xl bg-white p-6 shadow-md border-t-2 border-t-[#16abdb]">
      <h3 className="text-sm font-medium text-[#5e6b7c]">{title}</h3>
      <p className="mt-2 text-2xl font-semibold text-[#010d1d]">
        {disableAbbreviation ? value : abbreviateNumber(value)}
      </p>
    </div>
  );
};
